import Skeleton from '@Components/Utilities/Skeleton/Skeleton'
import SkeletonTitle from '@Components/Utilities/Skeleton/Components/SkeletonTitle'
import { FlexLayout } from '@eduact/ed-system'
import UnitErrorState from '@Features/Unit/Components/UnitErrorState'
import { skipToken } from '@reduxjs/toolkit/dist/query'
import { useState, useMemo } from 'react'
import { useParams } from 'react-router'
import styled from 'styled-components'
import EndPage from './Components/EndPage'
import NotActive from './Components/NoActiveTest'
import ReviewEndPage from './Components/ReviewEndPage'
import StartTest from './Components/StartTest'
import { useGetTestMcqUnitQuery } from './TestMcqApi/TestMcqApi'

const McqTest = () => {
	const { id } = useParams()
	const [testInfo] = useState<any>()
	const { currentData, status, isError, error, refetch } = useGetTestMcqUnitQuery(id ?? skipToken)

	const isOpened = useMemo(() => {
		return currentData?.data.trials?.opened
	}, [currentData?.data.trials?.opened])

	const isCompleted = useMemo(() => {
		return currentData?.data.trials?.completed
	}, [currentData?.data.trials?.completed])

	const attempt_id = useMemo(() => {
		return isCompleted?.filter(_ => _.test_id === currentData?.data.test.id).find(data => data.id)
	}, [isCompleted])

	// Real attempt number: completed attempts + 1 (the one about to start/continue).
	const attemptNumber = (isCompleted?.length ?? 0) + 1

	const renderTestPages = () => {
		if (isOpened) return <StartTest isContinue attemptNumber={attemptNumber} data={currentData?.data.test} />

		if (isCompleted && isCompleted?.length === 0) {
			return <StartTest attemptNumber={attemptNumber} data={currentData?.data.test} />
		}
		if (isCompleted && isCompleted?.length > 0 && isCompleted?.[0].score === null && isCompleted?.[0].evaluation_status === 'review') {
			return (
				<ReviewEndPage
					data={currentData?.data.test}
					opened={currentData?.data.trials?.opened}
					testInfo={testInfo}
					completed={isCompleted}
					attempt_id={attempt_id?.id}
				/>
			)
		}
		if (isCompleted && isCompleted?.length > 0 && isCompleted?.[0].score !== null) {
			return (
				<EndPage
					data={currentData?.data.test}
					opened={currentData?.data.trials?.opened}
					testInfo={testInfo}
					completed={isCompleted}
					attempt_id={attempt_id?.id}
				/>
			)
		}
	}

	if (isError) return <UnitErrorState error={error} onRetry={refetch} />

	if (!currentData || status !== 'fulfilled') {
		return (
			<Container>
				<FlexLayout justifyContent="center" flexDirection="column">
					<Skeleton isLoading width="100%" height="30vh" borderRadius="22px" mb="1rem" />
					<SkeletonTitle maxWidth="40%" width="40%" />
				</FlexLayout>
			</Container>
		)
	}

	return <Container>{currentData?.data.test.active ? renderTestPages() : <NotActive />}</Container>
}

const Container = styled.div`
	/* clear the bottom nav / sticky test bar on phones & tablets */
	@media (max-width: 1023px) {
		padding-bottom: var(--content-bottom-pad);
	}
`
export default McqTest
